import React from "react";
// import PropTypes from "prop-types";
import classes from "./styles.module.css";

const TabBarNav = ({navLabel, navLabelColor, navCount, onChangeActiveTab, isActive, isVisible}) => {

    const style = {
        active: {},
        hide: {}
    }

    if (isActive) {
        style.active = {
            color: "#333",
            backgroundColor: "#fff",
            borderColor: "#ddd #ddd #fff"
        }
    }

    if (!isVisible) return null;

    return (
        <button style={style.active}
                className={classes.Tab}
                data-label={navLabel}
                onClick={() => {
                    onChangeActiveTab(navLabel);
                }}>
            <span className={classes.TabAmount}>{navCount}</span>
            <span style={{color: navLabelColor}}>{navLabel}</span>
        </button>
    )
}

// TabBarNav.PropTypes = {
//     navLabel: PropTypes.string,
//     onChangeActiveTab: PropTypes.func,
//     isActive: PropTypes.bool
// }

// TabBarNav.defaultProps = {
//     navLabel: 'Tab',
//     onChangeActiveTab: () => {},
// }

export default TabBarNav;


// WEBPACK FOOTER //
// ./src/Components/Utils/HTabBar/TabBarNav.js